import { z } from 'zod';
import { CategoryKey } from './taxonomy.js';
export const DonationRecipientKind = z.enum(['personal', 'nonprofit', 'political_campaign']);
export const DonationSetupStatus = z.enum([
    'not_started',
    'in_progress',
    'action_required',
    'pending_verification',
    'active',
    'restricted',
    'disabled',
]);
export const DonationCategoryCapability = z.object({
    key: CategoryKey,
    label: z.string(),
    available: z.boolean().default(true),
    unavailableReason: z.string().nullable().default(null),
    defaultSelected: z.boolean(),
    recipientKinds: z.array(DonationRecipientKind),
});
export const DonationSettingsView = z.object({
    status: DonationSetupStatus,
    version: z.number().int().nonnegative(),
    masterEnabled: z.boolean(),
    recipientKind: DonationRecipientKind,
    selectedCategoryKeys: z.array(CategoryKey),
    showDonors: z.boolean(),
    allowAnonymous: z.boolean(),
    allowFeeCoverage: z.boolean(),
    eligibleCategories: z.array(DonationCategoryCapability),
    payout: z
        .object({
        id: z.string(),
        kind: z.enum(['bank', 'paypal']),
        display: z.string(),
    })
        .nullable(),
    actionRequired: z.string().nullable(),
    updatedAt: z.coerce.date().nullable(),
});
export const UpdateDonationSettingsInput = z.object({
    version: z.number().int().nonnegative(),
    masterEnabled: z.boolean(),
    recipientKind: DonationRecipientKind,
    selectedCategoryKeys: z.array(CategoryKey).max(20),
    showDonors: z.boolean(),
    allowAnonymous: z.boolean(),
    allowFeeCoverage: z.boolean(),
});
//# sourceMappingURL=donation.js.map